import React from "react";


const AxcBadge = ({
                    propInput = '',
                    propSuccessText = null,
                    propWarningText = null,
                    propMinorWarningText = null,
                    propDangerText = null,
                  }) => {

  let badgeClass;
  let bgColor = '#808080';

  if (propInput === propSuccessText) {
    badgeClass = 'badge text-bg-success';
  } else if (propInput === propWarningText) {
    badgeClass = 'badge text-dark';
    bgColor = '#fe8428';
  } else if (propInput === propMinorWarningText) {
    badgeClass = 'badge text-dark';
    bgColor = '#ffc600';
  } else if (propInput === propDangerText) {
    badgeClass = 'badge text-light';
    bgColor = '#fd001a';
  } else {
    badgeClass = 'badge text-bg-secondary';
  }

  return (
      <span className={badgeClass} style={{backgroundColor: bgColor}}>{propInput}</span>
  );
}

export default AxcBadge;